import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { AppSettingsService } from 'src/app/core/app-settings.service';
import { parseResponse } from 'src/app/core/helpers';
import {
  Email,
  EmailEditFormData,
  EmailResponse
} from 'src/app/core/module/email-interface';
const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};
@Injectable({
  providedIn: 'root'
})
export class EmailService {
  constructor(
    private http: HttpClient,
    private appSettingsService: AppSettingsService
  ) {}
  getEmail(queryParams: any): Observable<EmailResponse> {
    let params = this.appSettingsService.queryStringFormat(queryParams);

    return this.http.get('email-builder/list?' + params, httpOptions).pipe(
      map((resp: any) => {
        let retData: any = {
          items: [],
          totalCount: 0,
          error: ''
        };

        if (
          resp &&
          resp.data &&
          Array.isArray(resp.data.rows) &&
          resp?.error?.code <= 0
        ) {
          let rows = resp.data.rows;
          for (const item of rows) {
            let temp: EmailEditFormData = {
              ...item,
              type: item.type == 'fqApp' ? 'FQ Application' : 'Program'
            };
            retData.items.push(temp);
          }

          retData.totalCount = resp.data.count;
        } else {
          retData.error = resp?.error?.message ? resp.error.message : '';
        }

        return retData;
      })
    );
  }

  createEmail(data: EmailEditFormData): Observable<any> {
    return this.http.post('email', data, httpOptions).pipe(
      map((resp) => {
        return parseResponse(resp);
      })
    );
  }

  getByEmailId(id: any): Observable<Email> {
    return this.http.get('email-builder/' + id).pipe(
      map((resp: any) => {
        let Email: any;
        if (resp && resp.data) {
          let data = resp.data;
          Email = data;
        }
        return Email;
      })
    );
  }

  updateEmail(id: any, data: any): Observable<any> {
    return this.http.put('email-builder/' + id, data, httpOptions).pipe(
      map((resp) => {
        return parseResponse(resp);
      })
    );
  }

  deleteEmail(id: any): Observable<any> {
    return this.http.delete('email/' + id, httpOptions).pipe(
      map((resp) => {
        return parseResponse(resp);
      })
    );
  }

  //handle error messages
  handleError(err: any) {
    this.appSettingsService.handleError(err);
  }

  getAllEmail(): Observable<EmailResponse> {
    return this.http.get('email', httpOptions).pipe(
      map((resp: any) => {
        let retData: any = {
          items: [],
          totalCount: 0,
          error: ''
        };

        if (
          resp &&
          resp.data &&
          Array.isArray(resp.data.rows) &&
          resp?.error?.code <= 0
        ) {
          retData.items = resp.data.rows.map((item: any) => ({ ...item }));

          retData.totalCount = resp.data.count;
        } else {
          retData.error = resp?.error?.message ? resp.error.message : '';
        }

        return retData;
      })
    );
  }
}
